import { defineMessage, defineMessages } from 'react-intl';

export const closeShipmentText = defineMessage({
  description: 'EOD Close Shipment Action Text',
  defaultMessage: 'Close Shipments',
  id: 'c9IUno',
});

export const columnHeaderMessage = defineMessages({
  carrier: {
    description: 'EOD carrier Column Header',
    defaultMessage: 'Carrier',
    id: 'L3ixK5',
  },
  openShipment: {
    description: 'EOD openShipment Column Header',
    defaultMessage: 'Open Shipments',
    id: '+NO4FV',
  },
  actions: {
    description: 'EOD actions Column Header',
    defaultMessage: 'Actions',
    id: 'jzdhuo',
  },
});

export const pageMessages = defineMessages({
  openShipmentsDateSelection: {
    description: 'EOD Date Selection Message',
    defaultMessage: 'Open Shipments for <date></date>',
    id: '9XQ1Y+',
  },
  failedShipmentFetch: {
    description: 'EOD Failed to Fetch Open Shipments',
    defaultMessage: 'Failed to retrieve open shipments.',
    id: 'YfLLR1',
  },
  noShipmentsForDate: {
    description: 'EOD No Shipments For Selected Date Placeholder',
    defaultMessage: 'There are no open shipments for the selected date.',
    id: '/pQYTW',
  },
});

export const closeShipmentsModalMessages = defineMessages({
  modalHeader: {
    defaultMessage: 'Close Shipments',
    id: 'JrM5WF',
    description: 'Close Shipments Modal Header',
  },
  shipFromDDLabel: {
    defaultMessage: 'Locations:',
    id: 'vbIDId',
    description: 'Close Shipments Modal ShipFrom Dropdown Label',
  },
  descriptor: {
    defaultMessage:
      'Close these shipments to create the forms that may need to be presented at your carrier at the time of pickup.{linebreak}Closing shipments can happen multiple times per day, whenever necessary.',
    id: 'VJEO1Y',
    description: 'Close Shipments Modal Descriptor',
  },
  allShipFromsDDText: {
    defaultMessage: 'All Ship From Locations',
    id: 'k2EdVz',
    description: 'All Ship From Locations Option Text',
  },
  openShipmentsBlurb: {
    defaultMessage: 'Open {carrierName} Shipments ({shipmentCount})',
    id: 'hdoL9Z',
    description: 'EOD Open Shipments Modal Body Text',
  },
  closeSelectedButton: {
    defaultMessage: 'Close Selected',
    id: '55sl4c',
    description: 'Close Shipments Close Selected',
  },
  closeAllButton: {
    defaultMessage: 'Close All',
    id: 'gWoX2b',
    description: 'Close Shipments Close All',
  },
  closeButton: {
    defaultMessage: 'Close',
    id: 'zT/yY2',
    description: 'Close Modal Button',
  },
  successCloseInfoHeader: {
    defaultMessage: 'The following forms were created.',
    id: '3CEZES',
    description: 'Close Shipments Message success header',
  },
  successTableProviderHeader: {
    defaultMessage: 'Provider',
    id: '98MKsZ',
    description: 'Close Shipments Table Provider success message',
  },
  successTableShipmentsHeader: {
    defaultMessage: 'Shipments',
    id: 'xHDjIq',
    description: 'Close Shipments Table Shipments error header',
  },
  successTableActionsHeader: {
    defaultMessage: 'Action',
    id: 'y0u9tL',
    description: 'Close Shipments Table Action error header',
  },
  errorHeader: {
    defaultMessage: 'One or more errors were encountered when attempting to close shipments. Please review the errors below.',
    id: 'pFGP4v',
    description: 'Close Shipments Provider error message',
  },
  errorTableProviderHeader: {
    defaultMessage: 'Provider',
    id: 'mf+GfL',
    description: 'Close Shipments Table Provider error header',
  },
  errorTableMessageHeader: {
    defaultMessage: 'Error',
    id: 'KyJJ1S',
    description: 'Close Shipments Table Message error header',
  },
  printAllButton: {
    defaultMessage: 'Print All',
    id: 'y+FeEq',
    description: 'Close Shipments Print All Button',
  },
  printFormButton: {
    defaultMessage: 'Print Form',
    id: 'mWi3lg',
    description: 'Close Shipments Print Form Button',
  },
  awaitingPrintFormsTitle: {
    defaultMessage: 'Closing Selected Shipments',
    id: '6DoRRc',
    description: 'Close Shipments Awaiting Print Forms toast title',
  },
  awaitingPrintFormsMessage: {
    defaultMessage:
      'You may close the pop-up window and continue with other tasks while we close the shipments. An alert will appear when complete so you can print the forms.',
    id: 'zDnfUM',
    description: 'Close Shipments Awaiting Print Forms info message',
  },
  closeShipmentsErrorTitle: {
    description: 'error title for a notification of a failed network request',
    defaultMessage: 'ShipStation Could Not Close the Shipments',
    id: 'MI0NBK',
  },
  closeShipmentsErrorMessage: {
    description: 'error content for a notification of a failed network request',
    defaultMessage: 'Please try closing the shipments again. If the issue persists, contact our support team for further assistance.',
    id: '/c/k8a',
  },
  receivedPrintFormsErrorTitle: {
    description: 'error title for a notification of a shipments request that returned with carrier errors',
    defaultMessage: 'Unable to Close Selected Shipments',
    id: 'YUCzL8',
  },
  receivedPrintFormsErrorMessage: {
    description: 'error content for a notification of a shipments request that returned with carrier errors',
    defaultMessage:
      'The carrier returned some errors when attempting to close the shipments. Click here to review the errors then try to close your shipments again.',
    id: 's5OdmL',
  },
  receivedPrintFormsSuccessTitle: {
    description: 'success title for a notification of a successful network request for EOD print forms',
    defaultMessage: 'Shipments Closed Successfully',
    id: 'yURI9O',
  },
  receivedPrintFormsSuccessMessage: {
    description: 'success content for a notification of a successful network request for EOD print forms',
    defaultMessage: 'Your End of Day forms are ready! Click here to print them now or print from the Closed Shipments section at any time.',
    id: 'IPnzoZ',
  },
});
